import { List, Set } from 'immutable';
import * as iots from 'io-ts';
import { ResponseError, ResponseErrorArgs } from 'app/constants/ResponseErrors';
import { recordize } from 'app/remote/index';
import { Cause, Error } from 'app/constants/schemas';


export default class ApplicationError extends ResponseError {
  public error: Error;
  public constructor(values: ResponseErrorArgs, error: Error) {
    super({ ...values });
    this.error = error;
    this.code = this.error.code ?? undefined;
    this.meta = this.error.meta ?? undefined;
    this.message = this.error.detail ?? '';
    if (this.isAggregation() && this.error.causes && this.error.causes.size > 0) {
      this.causes = this.error.causes;
    } else {
      this.causes = List.of(new Cause({
        status: this.error.status,
        detail: this.error.detail,
        code: this.error.code,
        meta: this.error.meta,
      }));
    }
  }

  /**
   * @returns true if the error is an aggregation of errors
   */
  public isAggregation = () => {
    return !!(this.error.causes && !this.error.causes.isEmpty());
  };

  /**
   * @returns Set of unique error codes
   */
  public get codes(): Set<string> {
    const agg = (this.causes ?? List()).map((cause) => cause.code);
    return agg.filter(iots.string.is).toSet();
  }

  /**
   * @param error from the request
   * @returns an Application Error wrapping the response error.
   */
  public static parseResponseError(error: ResponseError) {
    const parsedError: Error = recordize({ data: error.response.error });
    return new ApplicationError(error.toJSON(), parsedError);
  }
}
